import moment from 'moment'

// Find number of weeks for a given year.
// Can be either 52 or 53
export function weeksInYear(year) {
  return Math.max(
    moment(new Date(year, 11, 31)).isoWeek(),
    moment(new Date(year, 11, 31 - 7)).isoWeek()
  )
}

export function toDateString(date) {
  return moment(date).format('YYYY-MM-DD')
}

export function formatDate(date, format = 'L') {
  return moment(date).format(format)
}

// Returns a collection of dates between start and stop.
// Arguments provided must be of the type moment
export function momentRange(start, end) {
  let current = start.clone(), days = []
  while (current <= end) {
    days.push(current.clone())
    current = current.add(1, 'days')
  }

  return days
}
